import { Box, BoxProps } from "@mui/material";

interface Trading212IconProps {
  size?: number;
  sx?: BoxProps['sx'];
}

const Trading212Icon = ({ size = 24, sx }: Trading212IconProps) => {
  return (
    <Box
      component="img"
      src="/trading212Icon.jpeg"
      alt="Trading212"
      sx={{
        width: size,
        height: size,
        borderRadius: 1,
        objectFit: 'contain',
        ...sx
      }}
    />
  );
};

export default Trading212Icon;